/*
 * @Author: Json Chen
 * @Date: 2021-06-29 17:17:12
 * @LastEditTime: 2021-07-02 15:45:54
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/language.ts
 */

import { get, post } from '@/src/tools/server';

export const getLanguageSetting = (salesChannelUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/languageSetting/${salesChannelUuid}`,
    {},
  );
};
export const getLanguageSettingTranslation = (salesChannelUuid, locale) => {
  return get<any>(
    `/portal/salesChannelSetting/languageSetting/translation/${salesChannelUuid}/${locale}`,
    {},
  );
};

export const setLanguageSetting = (body: any) => {
  return post<any>(`/portal/salesChannelSetting/languageSetting`, body, {});
};

export const languageSelection = (body: any) => {
  return post<any>(`/portal/salesChannelSetting/language/selection`, body, {});
};

export const salesChannelSettingImport = (salesChannelUuid, file) => {
  return post<any>(
    `/portal/salesChannelSetting/languageSetting/import${salesChannelUuid}`,
    file,
    {},
  );
};
